import { Api, Auth } from '../services'


export function getInitialSession() {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SESSION'
				})

				Api.get( '/wp/session', {
					secure_token: Auth.getToken(),
					device: 'web'
				}, ( data, error ) => {
					if ( error ) return;
					if( !!data.notification ) {
						dispatch({
							type: 'RECEIVE_VISIBLE_NOTIFICATION',
							notification: data.notification
						})
					}
					dispatch({
						type: 'RECEIVE_SESSION',
						session: 'session' in data ? data.session : 'expired',
						user: 'user' in data ? data.user : {}
					})
				})

			}
		)
	}
}


export function getSessionByAccessToken( network, AuthResponse ) {

	return ( dispatch, getStore ) => {

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SESSION'
				})

				Api.post( '/wp/session/oAuth/' + network + '/' + AuthResponse.access_token, {
					expires: AuthResponse.expires,
					device: 'web'
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_SESSION',
						session: data.session,
						user: data.user
					})
				})

			}
		)
	}
}


export function getSessionByEmail( data, stripe_customer_id ) {

	return ( dispatch, getStore ) => {

		if( !data.email || !data.password ) return

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SESSION'
				})

				let passedData = {
					password: data.password,
					cpassword: data.cpassword,
					stripe_customer_id: stripe_customer_id,
					device: 'web'
				}
				if( 'cpassword' in data ) passedData.cpassword = data.cpassword
				if( 'first_name' in data ) passedData.first_name = data.first_name
				if( 'last_name' in data ) passedData.last_name = data.last_name

				Api.post( '/wp/session/email/' + data.email, passedData, ( data, error ) => {
					if ( error ) {
						dispatch({
							type: 'RECEIVE_SESSION',
							user: {}
						})
						return;
					}
					dispatch({
						type: 'RECEIVE_SESSION',
						session: data.session,
						user: data.user
					})
				})

			}
		)
	}
}


export function removeSession( ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_DELETE_SESSION'
				})

				Api.delete( '/wp/session/user', {
					secure_token: Auth.getToken(),
					device: 'web'
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_DELETE_SESSION',
						session: data
					})
				})

			}
		)
	}
}


export function updateSessionUser( core_data, custom_data, acf_data, silently ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SESSION'
				})

				Api.put( '/wp/user/', {
					core_data: core_data ? core_data : {},
					custom_data: custom_data ? custom_data : {},
					acf_data: acf_data ? acf_data : {},
					silently: !!silently,
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					if( 'notification' in data ) {
						dispatch({
							type: 'RECEIVE_VISIBLE_NOTIFICATION',
							notification: data.notification
						})
					}
					dispatch({
						type: 'RECEIVE_SESSION',
						user: data.user
					})
				})

			}
		)
	}
}


export function addNetworkToUser( network, AuthResponse ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_SESSION'
				})

				Api.post( '/wp/user/network/' + network, {
					access_token: AuthResponse.access_token,
					expires: AuthResponse.expires,
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
					dispatch({
						type: 'RECEIVE_SESSION',
						user: data.user
					})
				})

			}
		)
	}
}


export function requestPasswordResetLink(email) {

	return ( dispatch, getStore ) => {

		if( !email ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_PASSWORD_RESET_LINK'
				})

				Api.post( '/wp/user/password-reset-link', {
					email: email
				}, ( data, error ) => {
					if ( error ) return;
					if( !!data ) {
						dispatch({
							type: 'RECEIVE_VISIBLE_NOTIFICATION',
							notification: data
						})
					}
					dispatch({
						type: 'RECEIVE_PASSWORD_RESET_LINK',
						success: !!data
					})
				})

			}
		)
	}
}


export function resetPassword(key, password, cpassword) {

	return ( dispatch, getStore ) => {

		if( !key || !password || !cpassword ) return;

		return dispatch(

			dispatch => {

				dispatch({
					type: 'REQUEST_PASSWORD_RESET'
				})

				Api.post( '/wp/user/password/reset', {
					key: key,
					password: password,
					cpassword: cpassword,
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data
					})
					dispatch({
						type: 'RECEIVE_PASSWORD_RESET',
						success: !!data
					})
				})

			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/actions/sessions.js